<template>
	<card class="metric-row">
		<div>
			<b><slot></slot></b>
		</div>
		<div class="is-flex is-justify-content-space-between">
			<div v-if="metric == 'partnerChange'">during report range</div>
			<div v-else>
				{{ nformat(current) }}
			</div>
			<div>
				<o-icon icon="chevron-circle-up" pack="fas" class="success" v-if="change > 0"></o-icon>
				<o-icon icon="minus" pack="fas" class="neutral" v-if="change == 0"></o-icon>
				<o-icon icon="chevron-circle-down" pack="fas" class="danger" v-if="change < 0"></o-icon>
				<span v-if="metric == 'partnerChange'">&nbsp;{{ difference }}</span>
				<span v-else>&nbsp;{{ pformat(change, 1) }}</span>
			</div>
		</div>
	</card>
</template>
<script>
	import { ref, computed, onMounted, inject } from "vue";
	import { currencyFormat, numberFormat } from "@/services/utils";

	export default {
		props: {
			metric: {
				type: String,
				default: ""
			},
			breakdown: {
				type: Object,
				default: () => {
					return undefined;
				}
			},
			report: {
				type: Object,
				default: undefined
			},
			results: {
				type: Array,
				default: () => {
					return [];
				}
			},
			compare: {
				type: Array,
				default: () => {
					return [];
				}
			}
		},
		setup(props, context) {
			const $financial = inject("$financial");
			const cformat = ref(currencyFormat.format);
			const nformat = ref(numberFormat.format);
			const pformat = ref(numberFormat.percent);

			const getBreakdownFilteredRows = (rows) => {
				if (!rows || rows.length === 0) return [];
				if (props.breakdown?.api?.BreakdownFilterResults) {
					return props.breakdown.api.BreakdownFilterResults(rows);
				}
				return rows;
			};

			const getTimeToFill = (isCompare) => {
				const reportRows = isCompare ? props.report?.compare : props.report?.results;
				const aggregateRows = isCompare ? props.compare : props.results;
				if (reportRows && reportRows.length > 0) {
					const rows = getBreakdownFilteredRows(reportRows);
					return isCompare ? $financial.compare.getTimeToFill(rows) : $financial.getTimeToFill(rows);
				}

				if (aggregateRows.length == 0) return 0;
				const weightedTotal = aggregateRows.reduce((acc, row) => {
					return acc + (row.timeToFillTotalDays || 0);
				}, 0);
				const weightedCount = aggregateRows.reduce((acc, row) => {
					return acc + (row.timeToFillCount || 0);
				}, 0);
				if (weightedCount > 0) {
					return weightedTotal / weightedCount;
				}
				return (
					aggregateRows.reduce((acc, row) => {
						return acc + row[props.metric];
					}, 0) / aggregateRows.length
				);
			};

			const current = computed(() => {
				if (props.metric == "timeToFill") {
					return getTimeToFill(false);
				} else {
					return props.results.reduce((acc, row) => {
						return acc + row[props.metric];
					}, 0);
				}
			});

			const previous = computed(() => {
				if (props.metric == "timeToFill") {
					return getTimeToFill(true);
				} else {
					return props.compare.reduce((acc, row) => {
						return acc + row[props.metric];
					}, 0);
				}
			});

			const difference = computed(() => {
				return current.value - previous.value;
			});

			const change = computed(() => {
				if (current.value === 0 && previous.value === 0) {
					return 0;
				} else if (previous.value === 0) {
					return 1;
				} else if (current.value === 0) {
					return previous.value > 0 ? -1 : 1;
				}

				return (current.value - previous.value) / Math.abs(previous.value);
			});

			return {
				cformat,
				nformat,
				pformat,
				current,
				previous,
				change,
				difference
			};
		}
	};
</script>
<style lang="scss" scoped>
	@import "@/assets/css/globalVars.scss";

	.metric-row {
		& .icon.success {
			color: $boyden-green;
		}
		& .icon.danger {
			color: $boyden-red;
		}
		& .icon.neutral {
			color: #ddd;
		}
	}

	// .metric-row {
	// 	& > table {
	// 		width: 100%;

	// 		& td:not(:first-child) {
	// 			text-align: right;
	// 		}
	// 	}

	// 	&.success {
	// 		// border-left: solid 4px $boyden-green;
	// 	}
	// 	&.danger {
	// 		// border-left: solid 4px $boyden-red;
	// 	}

	// 	& .icon {
	// 		color: #ddd;

	// 		&.success {
	// 			color: $boyden-green;
	// 		}
	// 		&.danger {
	// 			color: $boyden-red;
	// 		}
	// 	}
	// }
</style>
